import {ComplianceContent} from 'components/Compliance/ComplianceContent';

export const Compliance = () => <ComplianceContent />;
